import { useApi } from '../api/ApiContext'
import { clearPushSubscription } from '../features/settings/push'
import { clearLocalStorage } from '../lib/clearLocalStorage'
import { useAuth } from './AuthContext'

/**
 * `auth.signOut()`, plus what it doesn't do on its own: forgetting this browser's push subscription and clearing
 * every `macrotide.*` localStorage key it leaves behind (the active gym, the barcode cache, cached `/config` and
 * in-app messages, the theme — docs/legal/cookies.md). Every plain "Sign out" button uses this instead of calling
 * `auth.signOut()` straight, so the clearing happens in one place rather than once per button.
 * `DeleteAccountAction` does its own version of the same two steps around its own API call, rather than this.
 */
export function useSignOutAndClear(): () => Promise<void> {
  const auth = useAuth()
  const api = useApi()
  return async () => {
    await clearPushSubscription(api)
    clearLocalStorage()
    await auth.signOut()
  }
}
